"use strict";

const getIntervalPercentValue = (val, min, max) => {
    const valN = Number(val);
    const minN = Number(min);
    const maxN = Number(max);
    const res = (valN - minN) / (maxN - minN);
    return Math.min(100, Math.max(0, res));
};

const getIntervalValue = (percent, min, max) => {
    const percentN = Number(percent);
    if (percentN == 0) return min;
    if (percentN == 1) return max;
    const minN = Number(min);
    const maxN = Number(max);
    // Известная проблема javascipt:
    // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
    // Решается путём округления до 13 знака, если округлять до 14, то уже появляются числа
    // с плавающей точкой
    const fixedVal = +((maxN - minN) * percentN).toFixed(13);
    return fixedVal + minN;
};

const getMiddleColor = (min, max, percent) => {
    const startColor = ARGBtoObj(min);
    const endColor = ARGBtoObj(max);
    //(A1-(A1-B1)/h*x, A2-(A2-B2)/h*x, A3-(A3-B3)/h*x)
    const A = Math.ceil(startColor.a - (startColor.a - endColor.a) * percent);
    const R = Math.ceil(startColor.r - (startColor.r - endColor.r) * percent);
    const G = Math.ceil(startColor.g - (startColor.g - endColor.g) * percent);
    const B = Math.ceil(startColor.b - (startColor.b - endColor.b) * percent);
    return objToCSS({ a: A, r: R, g: G, b: B });
};

const getMiddleMatrixColor = (min, max, percent) => {
    const startColor = matrix2Color(min);
    const endColor = matrix2Color(max);
    return color2Matrix(getMiddleColor(startColor, endColor, percent));
};

const matrix2Color = value => {
    const numbers = value.split(" ");
    const obj = {
        r: Math.floor(numbers[0] * 255),
        g: Math.floor(numbers[6] * 255),
        b: Math.floor(numbers[12] * 255),
        a: Math.floor(numbers[18] * 255),
    };
    return objToARGB(obj);
};

const objToARGB = obj => {
    return String.format(
        "#{x2}{x2}{x2}{x2}",
        obj.a,
        obj.r,
        obj.g,
        obj.b
    );
};

const objToCSS = obj => {
    if (obj.a === 255) {
        return String.format("#{x2}{x2}{x2}", obj.r, obj.g, obj.b);
    } else {
        return String.format(
            "rgba({},{},{},{})",
            obj.r,
            obj.g,
            obj.b,
            (obj.a / 256).toFixed(3)
        );
    }
};

const isColor = color => {
    if (typeof color !== "string") return false;
    if (color.charAt(0) !== "#") {
        return window._enums.PredefinedColors.hasOwnProperty(
            color.toLowerCase()
        );
    } else {
        return (
            /#[A-Za-z0-9]{6}/.test(color) ||
            /#[A-Za-z0-9]{8}/.test(color) ||
            isARGB(color)
        );
    }
};

const getHexColor = value => {
    const color = ARGBtoObj(value);
    return objToCSS({ a: color.a, r: color.r, g: color.g, b: color.b });
};

export const getIntervalTime = (value, format = "dd.HH:mm:ss") => {
    let days;
    const rxTime = /^(d{1,2}\W)/i;
    const rxDays = /\W/;
    const isDays = rxTime.test(format);
    const absValue = Math.abs(value);
    if (isDays) {
        const indexDays = format.search(rxDays);
        format = format.slice(indexDays + 1);
        const MSEC_OF_DAY = 86400000;
        days = Math.floor(absValue / MSEC_OF_DAY);
    }
    let date = new Date(absValue);
    if (isNaN(date)) {
        const message = `Значение ${value} не может быть преобразовано в формат ${format}`;
        return new CustomConvertError("00.00:00:00", message);
    }
    const utc = window._df.dateFormat(date, format, true);
    return `${isDays ? `${days}.` : ""}${utc}`;
};

export const getConvertedValue = value => {
    return isColor(value) ? getHexColor(value) : value;
};

export const getFormattedValue = (
    format,
    value,
    type = null,
    idObj = null,
    checkInteger = false
) => {
    let res;
    try {
        if (
            type &&
            window._enums.Types[type] &&
            window._enums.Types[type].description
        ) {
            switch (window._enums.Types[type].description.descType) {
                case "time":
                    res = getIntervalTime(value, format);
                    break;
                case "tod":
                    res = window._df.dateFormat(new Date(value), format, true);
                    break;
                case "dt":
                    res = window._df.dateFormat(new Date(value), format, false);
                    break;
                default:
                    res = getFormattedNumericValue(format, value, checkInteger);
            }
        } else {
            res = getFormattedNumericValue(format, value, checkInteger);
        }
    } catch (err) {
        $ns.add({
            type: "error",
            time: new Date().toLocaleString(),
            title: err.name,
            text: err.message,
        });
    }
    if (
        res != null &&
        typeof res === "object" &&
        res.type === "customConvertError"
    ) {
        const path = idObj
            ? `${idObj.sourceId ? `FROM id="${idObj.sourceId}" ` : ``}${idObj.targetId ? `TO id="${idObj.targetId}":` : ``
            }`
            : "";
        res.err.text = `${path}<br> ${res.err.text}`;
        $ns.add(res.err);
        res = res.result;
    }
    return res;
};

export const getFormattedNumericValue = (format, value, checkInteger) => {
    if (value === null || value === undefined) return "";
    if (format === undefined || format == "") {
        return value.toString();
    }

    //экспоненциальный формат значений
    if (format.startsWith("e")) {
        try {
            return value.toExponential(format.substring(1));
        } catch (err) {
            //$ns.add({ type: 'error', time: new Date().toLocaleString(), title: err.name, text: err.message });
        }
    }

    const startsWithAllowedCharacter = ["f", "{f"].some(x =>
        format.startsWith(x)
    );
    if (
        checkInteger &&
        startsWithAllowedCharacter &&
        Math.trunc(value) === value
    ) {
        format = "f0";
    }

    return String.format(format, value);
};

export function CustomConvertError(result, message, type = "warning") {
    (this.type = "customConvertError"),
        (this.err = {
            type,
            time: new Date().toLocaleString(),
            title: `convert warning`,
            text: message,
        });
    this.result = result;
}

export const isColorMatrix = value => {
    const valmatrix = value.split(" ");
    const index = valmatrix.indexOf("");
    if (index > -1) {
        valmatrix.splice(index, 1);
    }
    return valmatrix.length == 20;
};

export const color2Matrix = value => {
    const color = ARGBtoObj(value);
    if (color) {
        value =
            color.r / 255 +
            " 0 0 0 0 0 " +
            color.g / 255 +
            " 0 0 0 0 0 " +
            color.b / 255 +
            " 0 0 0 0 0 " +
            color.a / 255 +
            " 0";
    } else {
        String.format(
            i18next.t("color_error_matrix"),
            value
        );
        $ns.add({
            type: "warning",
            time: new Date().toLocaleString(),
            title: "colorMatrix warning",
            text: message,
        });
        value = "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0";
    }
    return value;
};

export const ARGBtoObj = value => {
    if (!value) {
        return null;
    }
    if (isARGB(value)) {
        const [_, r, g, b, a = 1] = value.match(
            /rgb[a]?[(](\s*[0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*[,]?\s*([-+]?[0-9]*\.?[0-9]*)?[)]/
        );

        return {
            a: a * 255,
            r: parseInt(r),
            g: parseInt(g),
            b: parseInt(b),
        };
    }

    const v = value;
    //Solid #FFFFFFF
    value = value.replace(/Solid\s+/i, "");

    if (value.charAt(0) !== "#") {
        try {
            value = window._enums.PredefinedColors[value.trim().toLowerCase()];
            if (!value) return undefined;
        } catch (err) {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: "colorMatrix warning",
                text: "Invalid color value " + v,
            });
            return undefined;
        }
    }

    const colorValue = value.substr(1).toLowerCase();
    let alpha, red, green, blue;

    if (colorValue.length < 8) {
        alpha = "ff";
        red = colorValue.substr(0, 2);
        green = colorValue.substr(2, 2);
        blue = colorValue.substr(4, 2);
    } else {
        alpha = colorValue.substr(0, 2);
        red = colorValue.substr(2, 2);
        green = colorValue.substr(4, 2);
        blue = colorValue.substr(6, 2);
    }

    return {
        a: parseInt(alpha, 16),
        r: parseInt(red, 16),
        g: parseInt(green, 16),
        b: parseInt(blue, 16),
    };
};

export const isARGB = value => {
    if (
        /rgb[a]?[(](\s*[0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*[,]?\s*(?:[-+]?[0-9]*\.?[0-9]*)?[)]/.test(
            value
        )
    )
        //�������� � ��� � ������� rgb/rgba
        return true;
    else {
        return false;
    }
};

export const doRequest = obj => {
    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open(obj.method || "POST", obj.url);
        if (obj.headers) {
            for (let i = 0; i < array.length; i++) {
                const key = Object.keys(obj.headers)[i];
                xhr.setRequestHeader(key, obj.headers[key]);
            }
        }
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr.response);
            } else {
                reject(xhr.statusText);
            }
        };
        xhr.onerror = () => reject(xhr.statusText);
        xhr.send(obj.url);
    });
};

export function toBool(value) {
    if (value) {
        if (typeof value == "boolean") {
            return value;
        } else {
            switch (value.toString().toLowerCase().trim()) {
                case "true":
                case "yes":
                case "1":
                    return true;
                case "false":
                case "no":
                case "0":
                case null:
                    return false;
                default:
                    return Boolean(value);
            }
        }
    } else {
        return false;
    }
}

export function covertToType(valStringType, type) {
    switch (type) {
        case "number": {
            return +valStringType;
        }
        case "boolean": {
            return toBool(valStringType);
        }
        default: {
            return valStringType;
        }
    }
}

export function convertToTypesForCompare(oper, value){
    let operand = oper;
    let val = value;
    const isOperandString = typeof operand === "string";
    const isValString = typeof val === "string";
    if (!isOperandString && isValString)
        val = covertToType(val, typeof operand);
    else if (isOperandString && !isValString)
        operand = covertToType(operand, typeof val);
    return {operand, val}
}

export function toWindows1251(str) {
    const DMap = {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        10: 10,
        11: 11,
        12: 12,
        13: 13,
        14: 14,
        15: 15,
        16: 16,
        17: 17,
        18: 18,
        19: 19,
        20: 20,
        21: 21,
        22: 22,
        23: 23,
        24: 24,
        25: 25,
        26: 26,
        27: 27,
        28: 28,
        29: 29,
        30: 30,
        31: 31,
        32: 32,
        33: 33,
        34: 34,
        35: 35,
        36: 36,
        37: 37,
        38: 38,
        39: 39,
        40: 40,
        41: 41,
        42: 42,
        43: 43,
        44: 44,
        45: 45,
        46: 46,
        47: 47,
        48: 48,
        49: 49,
        50: 50,
        51: 51,
        52: 52,
        53: 53,
        54: 54,
        55: 55,
        56: 56,
        57: 57,
        58: 58,
        59: 59,
        60: 60,
        61: 61,
        62: 62,
        63: 63,
        64: 64,
        65: 65,
        66: 66,
        67: 67,
        68: 68,
        69: 69,
        70: 70,
        71: 71,
        72: 72,
        73: 73,
        74: 74,
        75: 75,
        76: 76,
        77: 77,
        78: 78,
        79: 79,
        80: 80,
        81: 81,
        82: 82,
        83: 83,
        84: 84,
        85: 85,
        86: 86,
        87: 87,
        88: 88,
        89: 89,
        90: 90,
        91: 91,
        92: 92,
        93: 93,
        94: 94,
        95: 95,
        96: 96,
        97: 97,
        98: 98,
        99: 99,
        100: 100,
        101: 101,
        102: 102,
        103: 103,
        104: 104,
        105: 105,
        106: 106,
        107: 107,
        108: 108,
        109: 109,
        110: 110,
        111: 111,
        112: 112,
        113: 113,
        114: 114,
        115: 115,
        116: 116,
        117: 117,
        118: 118,
        119: 119,
        120: 120,
        121: 121,
        122: 122,
        123: 123,
        124: 124,
        125: 125,
        126: 126,
        127: 127,
        1027: 129,
        8225: 135,
        1046: 198,
        8222: 132,
        1047: 199,
        1168: 165,
        1048: 200,
        1113: 154,
        1049: 201,
        1045: 197,
        1050: 202,
        1028: 170,
        160: 160,
        1040: 192,
        1051: 203,
        164: 164,
        166: 166,
        167: 167,
        169: 169,
        171: 171,
        172: 172,
        173: 173,
        174: 174,
        1053: 205,
        176: 176,
        177: 177,
        1114: 156,
        181: 181,
        182: 182,
        183: 183,
        8221: 148,
        187: 187,
        1029: 189,
        1056: 208,
        1057: 209,
        1058: 210,
        8364: 136,
        1112: 188,
        1115: 158,
        1059: 211,
        1060: 212,
        1030: 178,
        1061: 213,
        1062: 214,
        1063: 215,
        1116: 157,
        1064: 216,
        1065: 217,
        1031: 175,
        1066: 218,
        1067: 219,
        1068: 220,
        1069: 221,
        1070: 222,
        1032: 163,
        8226: 149,
        1071: 223,
        1072: 224,
        8482: 153,
        1073: 225,
        8240: 137,
        1118: 162,
        1074: 226,
        1110: 179,
        8230: 133,
        1075: 227,
        1033: 138,
        1076: 228,
        1077: 229,
        8211: 150,
        1078: 230,
        1119: 159,
        1079: 231,
        1042: 194,
        1080: 232,
        1034: 140,
        1025: 168,
        1081: 233,
        1082: 234,
        8212: 151,
        1083: 235,
        1169: 180,
        1084: 236,
        1052: 204,
        1085: 237,
        1035: 142,
        1086: 238,
        1087: 239,
        1088: 240,
        1089: 241,
        1090: 242,
        1036: 141,
        1041: 193,
        1091: 243,
        1092: 244,
        8224: 134,
        1093: 245,
        8470: 185,
        1094: 246,
        1054: 206,
        1095: 247,
        1096: 248,
        8249: 139,
        1097: 249,
        1098: 250,
        1044: 196,
        1099: 251,
        1111: 191,
        1055: 207,
        1100: 252,
        1038: 161,
        8220: 147,
        1101: 253,
        8250: 155,
        1102: 254,
        8216: 145,
        1103: 255,
        1043: 195,
        1105: 184,
        1039: 143,
        1026: 128,
        1106: 144,
        8218: 130,
        1107: 131,
        8217: 146,
        1108: 186,
        1109: 190,
    };
    let L = [];
    for (let i = 0; i < str.length; i++) {
        const ord = str.charCodeAt(i);
        if (!(ord in DMap))
            throw "Character " + str.charAt(i) + " isn't supported by win1251!";
        L.push(String.fromCharCode(DMap[ord]));
    }
    str = L.join("");

    const send_arr = new Uint8Array(str.length);
    for (var i = 0; i < str.length; ++i) send_arr[i] = str.charCodeAt(i);
    return send_arr;
}

export function exportTextfile(row, fileName, foceName) {
    const charset = window._globalParams.SaveEncodingCsv || "utf-8";
    if (charset.toLowerCase() === "windows-1251") {
        row = toWindows1251(row);
    }

    const bl = new Blob([row], { type: `text/plain;charset=${charset}` });
    if (window.eFs && window.savePath && window.eFs.get().existsSync(window.savePath)) {
        window.eFs
            .get()
            .writeFile(`${window.savePath}${fileName}`, row, "utf-8", err => {
                if (err) {
                    $ns.add({
                        type: "error",
                        time: new Date().toLocaleString(),
                        title: i18next.t("write_file_error"),
                        text: String.format(i18next.t("write_file_errors", window.savePath, fileName, window.saveDeviceDesc)),
                    });
                }
            });
    } else {
        const anchor = document.createElement("a");
        anchor.href = window.URL.createObjectURL(bl);
        anchor.download = `${fileName}${fileName.endsWith(".csv") ? "" : ".csv"
            }`;
        anchor.dataset.downloadurl = [
            `text/plain;charset=${charset}`,
            anchor.download,
            anchor.href,
        ].join(":");
        anchor.click();
    }
}

export function generateFileName(format, controlName, objectid) {
    // Если окно вытащено не из объекта, то у него не будет objectid,
    // поэтому нужно использовать только имя контрола
    let newFormat = format.replaceAll("{Name}", controlName);
    if (objectid && objectid !== "0") {
        const { _Name = "", _Description = "" } = $pr.itemsMap[objectid];
        newFormat = newFormat
            .replaceAll("{ObjectName}", _Name)
            .replaceAll("{ObjectDescription}", _Description);
    }

    const hasDateFormat = newFormat.indexOf("{") > -1;
    return hasDateFormat ? getFormattedValue(newFormat, new Date()) : newFormat;
}

/**
 * Глубокое сравнение двух Объектов (массивов)
 *
 * @export
 * @param {*} oldVal первый объект
 * @param {*} newVal второй объект
 * @return {boolean} равны ты объкты
 */
export function deepCompare(oldVal, newVal) {
    if (oldVal === newVal) return true;
    if (
        typeof oldVal === "object" &&
        oldVal !== null &&
        typeof newVal === "object" &&
        newVal !== null
    ) {
        const value = newVal.value ? newVal.value : newVal;
        return compareObj(oldVal, value);
    } else {
        return false;
    }
}
function compareObj(v1, v2) {
    const k1 = Object.keys(v1 || {});
    const k2 = Object.keys(v2 || {});
    if (k1.length !== k2.length) return false;
    for (const key of k1) {
        if (typeof v2[key] === "undefined") return false;
        if (typeof v1[key] === "object") {
            if (!compareObj(v1[key], v2[key])) return false;
        } else {
            if (v1[key] !== v2[key]) return false;
        }
    }
    return true;
}
/**
 * Performs a deep merge of `source` into `target`.
 * Mutates `target` only but not its objects and arrays.
 *
 * @author inspired by [jhildenbiddle](https://stackoverflow.com/a/48218209).
 */
export function mergeDeep(target, source) {
    const isObject = obj => obj && typeof obj === "object";

    if (!isObject(target) || !isObject(source)) {
        return source;
    }

    Object.keys(source).forEach(key => {
        const targetValue = target[key];
        const sourceValue = source[key];

        if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
            target[key] = targetValue.concat(sourceValue);
        } else if (isObject(targetValue) && isObject(sourceValue)) {
            target[key] = mergeDeep(
                Object.assign({}, targetValue),
                sourceValue
            );
        } else {
            target[key] = sourceValue;
        }
    });

    return target;
}
export function interpolate(variable, i) {
    let tmps = getIntervalPercentValue(
        variable,
        this.sourcePoints[i],
        this.sourcePoints[i + 1]
    );
    if (this.TargetType === "brush") {
        return getMiddleColor(
            this.targetPoints[i],
            this.targetPoints[i + 1],
            tmps
        );
    } else if (this.TargetType === "matrix") {
        return getMiddleMatrixColor(
            this.targetPoints[i],
            this.targetPoints[i + 1],
            tmps
        );
    } else {
        return getIntervalValue(
            tmps,
            this.targetPoints[i],
            this.targetPoints[i + 1]
        );
    }
}

var nextUniqueNumber = 1;
export function getUniqueNumber() {
    return nextUniqueNumber++;
}

export function getElementByIdInContext(root, id) {
    let parent = root;
    while (parent) {
        let elem = parent.querySelector("#" + CSS.escape(id));
        if (elem) return elem;
        parent = parent.parentElement;
    }
    return document.getElementById(id);
}

/*
 * Тип шкалы - простой, log10
 */
export function processScaleType(value, uselogscale) {
    if (uselogscale) {
        if (value <= 0) {
            return 0;
        }
        try {
            return Math.log10(value);
        } catch {
            return value;
        }
    }
    return value;
}

/*
 * Тип шкалы - простой, log10
 */
export function unprocessScaleType(value, uselogscale) {
    if (uselogscale) {
        if (value <= 0) {
            return 0;
        }
        try {
            return Math.pow(10, value);
        } catch {
            return value;
        }
    }
    return value;
}

export function debounce(fn, ms) {
    let timer;
    return function () {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, arguments), ms);
    };
}

export function throttle(fn, ms) {
    let isFnRun = false;
    let lastArgs;
    let lastContext;

    const wrapper = function () {
        if (isFnRun) {
            lastArgs = arguments;
            lastContext = this;
            return;
        }

        fn.apply(this, arguments);
        isFnRun = true;

        setTimeout(() => {
            isFnRun = false;
            if (lastArgs) {
                wrapper.apply(lastContext, lastArgs);
                lastContext = null;
                lastArgs = null;
            }
        }, ms);
    };

    return wrapper;
}

export function deepClone(obj, isLowerCase) {
    let out = Array.isArray(obj) ? [] : {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            let value = obj[key];
            out[isLowerCase ? key.toLocaleLowerCase() : key] = typeof value === "object" ? deepClone(value) : value;
        }
    }
    return out;
}

export function isNullOrUndefined(value) {
    return value === undefined || value === null
}

export function convertPropertyPath(value) {
    const p = value.indexOf(".");
    if (p < 0)
        return value.toLowerCase();

    return value.substr(0, p).toLowerCase() + value.substr(p);
}

export function getBrowserInfo() {
    const userAgent = navigator.userAgent;
    let browserName, browserVersion;
    
    if (/firefox|fxios/i.test(userAgent)) {
        browserName = 'Firefox';
        browserVersion = userAgent.match(/Firefox\/([0-9\.]+)/)[1];
    } else if (/opr\//i.test(userAgent)) {
        browserName = 'Opera';
        browserVersion = userAgent.match(/OPR\/([0-9\.]+)/)[1];
    } else if (/chrome|crios/i.test(userAgent) && !/yabrowser/i.test(userAgent) && !/edg/i.test(userAgent)) {
        browserName = 'Chrome';
        browserVersion = userAgent.match(/Chrome\/([0-9\.]+)/)[1];
    } else if (/yabrowser/i.test(userAgent)) {
        browserName = 'Yandex Browser';
        browserVersion = userAgent.match(/YaBrowser\/([0-9\.]+)/)[1];
    } else if (/safari/i.test(userAgent) && !/chrome|crios/i.test(userAgent)) {
        browserName = 'Safari';
        browserVersion = userAgent.match(/Version\/([0-9\.]+)/)[1];
    } else if (/trident/i.test(userAgent)) {
        browserName = 'Internet Explorer';
        browserVersion = userAgent.match(/rv:([0-9\.]+)/)[1];
    } else if (/edg/i.test(userAgent)) {
        browserName = 'Edge';
        browserVersion = userAgent.match(/Edg\/([0-9\.]+)/)[1];
    } else {
        browserName = 'Unknown';
        browserVersion = 'Unknown';
    }

    return { name: browserName, version: browserVersion };
}

export function isGoodStatusCode(statusCode){
    return (statusCode & 0xC0000000) === 0x00000000
}